<template>
  <View gap="sm" align="center" class="url-field">
    <div class="url">
      <!-- Readonly, not a plain text: a focus selects the whole URL, for an owner who copies by hand -->
      <Input :model-value="url" readonly aria-label="Apply link" @focus="selectAll" />
    </div>

    <Button :variant="variant" size="medium" @click="copy">
      <Icon name="copy" size="small" />
      <span>Copy link</span>
    </Button>
  </View>
</template>

<script setup lang="ts">
import { Button, Icon, Input, View, useAlertsStore } from '@tallo/design-system';

const props = withDefaults(defineProps<{ url: string; variant?: 'primary' | 'outline' }>(), { variant: 'primary' });

const alertsStore = useAlertsStore();

function selectAll(event: FocusEvent) {
  (event.target as HTMLInputElement).select();
}

function copy() {
  navigator.clipboard
    .writeText(props.url)
    .then(() => alertsStore.success('Apply link copied'))
    .catch(() => alertsStore.error('Could not copy the link. Select it and copy it instead.'));
}
</script>

<style scoped lang="scss">
.url {
  flex: 1;
  min-width: 0;

  // Readonly: the grey of a field you copy from, not one you type in
  :deep(.input-wrapper) {
    width: 100%;
    background-color: var(--t-color-neutral-100);
  }

  :deep(input) {
    font-family: ui-monospace, Menlo, monospace;
    text-overflow: ellipsis;
  }
}
</style>
